import { createAction, handleActions } from 'redux-actions';

const PM_NOTICE_INFO = 'pm/PM_NOTICE_INFO';

export const setPmNoticeInfo = createAction(
  PM_NOTICE_INFO,
  (data) => data
);

const initialState = {
  info: null
};

const pmNotice = handleActions(
  {
    [PM_NOTICE_INFO]: (state, { payload: data }) => ({
      ...state,
      info: data
    })
  },
  initialState
)

export default pmNotice;